import { fromJS, List } from 'immutable';
import { SET_WATCH_LIST, SET_WATCHED, WATCH_GAME } from './constants';
import { APP_RESET } from '../App/constants';

/** A game from the server in the shape the games list draws: its players a plain list. */
export const asGame = (game) => fromJS({ ...game, users: (game.users && game.users.data) || [] });

const initialState = fromJS({ list: null, game: null, log: [] });

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_WATCH_LIST:
      return state.set('list', List(action.payload.games.map(asGame)));
    case WATCH_GAME:
      return state.set('game', null).set('log', List());
    case SET_WATCHED:
      // The log stays plain entries, read by describeEntry.
      return state.set('game', asGame(action.payload.game)).set('log', action.payload.log);
    case APP_RESET:
      return initialState;
    default:
      return state;
  }
}

export default reducer;
